import script from "./ui-list-view-item-check.vue?vue&type=script&setup=true&lang=ts"
export * from "./ui-list-view-item-check.vue?vue&type=script&setup=true&lang=ts"

import "./ui-list-view-item-check.vue?vue&type=style&index=0&id=010e4e0c&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010e4e0c"]])

export default __exports__